/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import {
    Label,
    NumericLabel,
    StyledLink
} from 'src/luis/projects/analytics/components/IntentsWithErrorsCard/FaultyIntentDetails/Legend/LegendStyles';
import { LegendColor, LegendItem } from 'src/luis/projects/analytics/components/TrainingEvaluation/Legend/LegendItem';
import { Row } from 'src/luis/projects/analytics/components/TrainingEvaluation/Legend/LegendRowHelpers';
import { FaultyIntent } from 'src/luis/projects/analytics/types/FaultyIntent';

export type LegendRowProps = {
    /**
     * The displayed intent of the legend row
     */
    intent: FaultyIntent;

    /**
     * The label prefix of the legend row.
     */
    labelPrefix: string;

    /**
     * The color of the legend item.
     */
    legendColor: LegendColor;

    /**
     * A callback for when an intent is clicked.
     */
    onIntentClick: () => void;
};

/**
 * Represents a generic legend row of the intents with errors card.
 */
export const LegendRow = (props: LegendRowProps) => {
    const { intent, onIntentClick, legendColor, labelPrefix } = props;

    return (
        <Row>
            <Label>
                <LegendItem color={legendColor} />
                <StyledLink onClick={onIntentClick}>
                    {labelPrefix} {intent.name}
                </StyledLink>
            </Label>
            <NumericLabel>
                <StyledLink onClick={onIntentClick}>{intent.utterancesCount}</StyledLink>
            </NumericLabel>
        </Row>
    );
};
